"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSegmentConsentWrapper = exports.hasAdvertisingConsent = void 0;
const analytics_consent_tools_1 = require("@segment/analytics-consent-tools");
const mappers_1 = require("./mappers");
const store_1 = require("./store");
const toCategories = (prefs) => (0, mappers_1.mapHubspotConsentToSegmentPreferences)(prefs);
const hasAdvertisingConsent = () => {
    const prefs = store_1.$consentPreferences.get();
    return prefs.allowed || prefs.categories.advertisement;
};
exports.hasAdvertisingConsent = hasAdvertisingConsent;
const createSegmentConsentWrapper = (isReady = () => true) => (0, analytics_consent_tools_1.createWrapper)({
    shouldLoadSegment: async (ctx) => {
        await (0, analytics_consent_tools_1.resolveWhen)(() => (0, exports.hasAdvertisingConsent)() && isReady(), 500);
        return ctx.load({ consentModel: 'opt-out' });
    },
    getCategories: () => toCategories(store_1.$consentPreferences.get()),
    registerOnConsentChanged: (setCategories) => store_1.$consentPreferences.listen((prefs) => setCategories(toCategories(prefs))),
});
exports.createSegmentConsentWrapper = createSegmentConsentWrapper;
